/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. ATGCTAGCTAGC`)
};

const es_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. ATGCTAGCTAGC`)
};

const de_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. ATGCTAGCTAGC`)
};

const nl_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. ATGCTAGCTAGC`)
};

const fr_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. ATGCTAGCTAGC`)
};

const it_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. ATGCTAGCTAGC`)
};

const pt_br2_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex.: ATGCTAGCTAGC`)
};

const pt_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por ex. ATGCTAGCTAGC`)
};

const ja_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: ATGCTAGCTAGC`)
};

const zh_revcomp_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 ATGCTAGCTAGC`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_input_placeholder", locale)
	if (locale === "en") return en_revcomp_input_placeholder(inputs)
	if (locale === "es") return es_revcomp_input_placeholder(inputs)
	if (locale === "de") return de_revcomp_input_placeholder(inputs)
	if (locale === "nl") return nl_revcomp_input_placeholder(inputs)
	if (locale === "fr") return fr_revcomp_input_placeholder(inputs)
	if (locale === "it") return it_revcomp_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_input_placeholder(inputs)
	if (locale === "pt") return pt_revcomp_input_placeholder(inputs)
	if (locale === "ja") return ja_revcomp_input_placeholder(inputs)
	return zh_revcomp_input_placeholder(inputs)
};